<template>
  <c-modal v-if="client" class="edit-client" :title="title" size="lg" :show="show" @update:show="toggle">
    <c-input
        v-model="form.name"
        label="Name"
        type="text"
        placeholder="Enter client name"
        :lazy="false"
        :is-valid="checkIfValid('name')"
        invalid-feedback="Please enter a client name"
    />
    <c-input
        v-model="form.contactName"
        label="Contact name"
        type="text"
        placeholder="Enter contact name"
        :lazy="false"
        :is-valid="checkIfValid('contactName')"
        invalid-feedback="Please enter a contact name"
    />
    <c-input
        v-model="form.contactEmailAddress"
        label="Contact email address"
        type="text"
        placeholder="Enter email"
        :lazy="false"
        :is-valid="checkIfValid('contactEmailAddress')"
        invalid-feedback="Please enter a valid contact email"
    />

    <template v-slot:footer>
      <c-button-group>
        <c-button color="primary" :disabled="isSaving" @click="save">Save</c-button>
        <c-button color="secondary" @click="close">Cancel</c-button>
      </c-button-group>
    </template>
  </c-modal>
</template>

<script>
import { validationMixin } from 'vuelidate';
import {
  required, email,
} from 'vuelidate/lib/validators';

import { buildEndpoint } from '@/libs/buildEndPoint';

export default {
  name: 'EditClient',
  mixins: [validationMixin],
  props: {
    show: Boolean,
    client: Object,
  },
  data() {
    return {
      isSaving: false,
      form: {
        name: '',
        contactName: '',
        contactEmailAddress: '',
      },
    };
  },
  computed: {
    title() {
      return `Edit ${this.client.name}`;
    },
    isValid() {
      return !this.$v.form.$invalid;
    },
    isDirty() {
      return this.$v.form.$anyDirty;
    },
  },
  validations: {
    form: {
      name: {
        required,
      },
      contactName: {
        required,
      },
      contactEmailAddress: {
        required,
        email,
      },
    },
  },
  mounted() {
    this.setData();
  },
  methods: {
    setData() {
      this.form.name = this.client.name;
      this.form.contactName = this.client.contactName;
      this.form.contactEmailAddress = this.client.contactEmailAddress;
    },
    toggle(event) {
      if (!event) {
        this.close();
      }
    },
    checkIfValid(fieldName) {
      const field = this.$v.form[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === '');
    },
    close() {
      this.$v.$reset();
      this.setData();
      this.$emit('close');
    },
    save() {
      this.$v.$touch();

      if (!this.isValid) {
        return;
      }
      this.isSaving = true;

      const data = { ...this.form, clientId: this.client._id };

      this.$http
        .post(buildEndpoint('clients/update'), data)
        .then((response) => {
          this.isSaving = false;
          if (response.data.success) {
            this.$store.commit('addSuccessMessage', {
              header: 'Success',
              message: 'Client updated',
            });
            this.$emit('updated', data);
            this.close();
          } else {
            this.$store.commit('addErrorMessage', {
              header: 'Error',
              message: 'Error saving client data',
            });
          }
        })
        .catch((error) => {
          this.isSaving = false;
          this.$store.commit('addErrorMessage', {
            header: 'Error',
            message: error,
          });
        });
    },
  },
};
</script>
